import script from "./tenants-guarantors.vue?vue&type=script&setup=true&lang=ts"
export * from "./tenants-guarantors.vue?vue&type=script&setup=true&lang=ts"

import "./tenants-guarantors.vue?vue&type=style&index=0&id=1446f040&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1446f040"]])

export default __exports__